// src/pages/Level-10.jsx
import React, { useMemo } from "react";
import Level10Layout from "./Level-10Layout";
import { STREAM_VIDEOS } from "../videos/streamVideos";

/**
 * Level 10 (Final Doron Battle) — Für Elise excerpt
 * - No lyrics
 * - 6 lines repeated twice = 12 lines
 * - Uses Cloudflare Stream video
 */

// ⬇️ Fallback Stream ID (from your screenshot)
const LEVEL10_FALLBACK_STREAM_ID = "2c43e4070a846c305c4b71a31e8c92dd";

const LEVEL10_STREAM_ID =
  STREAM_VIDEOS?.L10_FINAL_BATTLE_INTRO?.id || LEVEL10_FALLBACK_STREAM_ID;

// ✅ Level10Layout supports: videoSrc="stream:<id>"
const LEVEL10_VIDEO_SRC = `stream:${LEVEL10_STREAM_ID}`;

// ✅ IMPORTANT: production is case-sensitive and your repo tracks "Doron.png"
const ASSET_V = "2"; // bump when you want cache-bust again

const DORON_BOSS_IMAGE = `/images/Doron.png?v=${ASSET_V}`;
const DORON_SLEEP_IMAGE = `/images/${encodeURIComponent(
  "Sleeping Doron.png"
)}?v=${ASSET_V}`;

export default function Level10() {
  const melodyLines = useMemo(() => {
    const pass = [
      // 1 : E5 D#5 E5 D#5 E5  B D5 C5 A
      { notes: ["E5", "D#5", "E5", "D#5", "E5", "B4", "D5", "C5", "A4"] },

      // 2 : C E A B
      { notes: ["C4", "E4", "A4", "B4"] },

      // 3 : E G# B C5
      { notes: ["E4", "G#4", "B4", "C5"] },

      // 4 : E5 D#5 E5 D#5 E5  B D5 C5 A
      { notes: ["E5", "D#5", "E5", "D#5", "E5", "B4", "D5", "C5", "A4"] },

      // 5 : C E A B
      { notes: ["C4", "E4", "A4", "B4"] },

      // 6 : E C5 B A
      { notes: ["E4", "C5", "B4", "A4"] },
    ];

    return [...pass, ...pass]; // repeat twice ✅ => 12 lines
  }, []);

  return (
    <Level10Layout
      levelId={10}
      videoSrc={LEVEL10_VIDEO_SRC}
      doronImageSrc={DORON_BOSS_IMAGE}
      doronSleepImageSrc={DORON_SLEEP_IMAGE}
      melodyLines={melodyLines}
      firstKeyOverride="C4"
      lastKeyOverride="E5"
    />
  );
}
